import { action } from 'typesafe-actions';
// Fetch credits
export const FETCH_CREDITS_REQUEST = '[Request] Fetch credits';
export const FETCH_CREDITS_SUCCESS = '[Success] Fetch credits';
export const FETCH_CREDITS_FAILURE = '[Failure] Fetch credits';
export const fetchCreditsRequest = (address) => action(FETCH_CREDITS_REQUEST, { address });
export const fetchCreditsSuccess = (address, credits) => action(FETCH_CREDITS_SUCCESS, { address, credits });
export const fetchCreditsFailure = (address, error) => action(FETCH_CREDITS_FAILURE, { address, error });
// Poll Credits Balance
export const POLL_CREDITS_BALANCE_REQUEST = '[Request] Poll credits balance';
export const pollCreditsBalanceRequest = (address, expectedBalance) => action(POLL_CREDITS_BALANCE_REQUEST, { address, expectedBalance });
// Credits real-time updates via SSE
export const START_CREDITS_SSE = '[Request] Start credits SSE connection';
export const STOP_CREDITS_SSE = '[Request] Stop credits SSE connection';
export const startCreditsSSE = (address) => action(START_CREDITS_SSE, { address });
export const stopCreditsSSE = () => action(STOP_CREDITS_SSE);
// For backward compatibility
export const START_CREDITS_AUTO_POLLING = START_CREDITS_SSE;
export const STOP_CREDITS_AUTO_POLLING = STOP_CREDITS_SSE;
export const startCreditsAutoPolling = startCreditsSSE;
export const stopCreditsAutoPolling = stopCreditsSSE;
//# sourceMappingURL=actions.js.map